import { ServiceDeliveryBacklogDetailInfo } from "./ServiceDeliveryBacklogDetailInfo.model"

export class ProjectPipelineInfo {
  ProjectPipelineId: number
  ProjectPipelineProjectSaleId: number
  ProjectSaleCode: string
  ProjectPipelineSubStateCode: string
  ProjectPipelineSubStateName: string
  ProjectPipelineStatusLookupCode: string
  ProjectPipelineStatusLookupValue: string
  ProjectSaleName: string
  ProjectPipelineClose: string
  ProjectPipelineAmount: number
  ProjectPipelineComission: number
  ProjectPipelinePriority: string
  ProjectPipelineDisplayPriority: string
  ProjectPipelineProgress: string
  ProjectPipelineDisplayProgress: string
  ProjectPipelineProbability: number
  ProjectPipelineRemark: string
  ProjectPipelineCreateDate: string
  ProjectPipelineCreateBy: string
  ProjectPipelineDisplayCreateBy: string
  ProjectPipelineUpdateDate: string
  ProjectPipelineUpdateBy: string
  ProjectPipelineDisplayUpdateBy: string
  ProjectPipelineFlagDelete: string

  ProjectPipelineCompanyCode: string
  ProjectPipelineCompanyName: string
  ProjectPipelineSaleTeamCode: string
  ProjectPipelineSearchSaleTeamEmpCode: string
  ProjectPipelineCustomFilter: string

  StartDate: string
  EndDate: string

  ProjectSaleClosedPeriodMonth: string
  ProjectSaleClosedPeriodYear: string
  ProjectSaleCloseDealProgress: string
  ProjectSaleId: number
  ProjectSaleTeamCode: string
  ProjectSaleCreateBy: string
  ProjectSaleState: string

  //ProjectSaleServiceDeliveryStatus: string
  ProjectSaleServiceDeliveryWaitingAmount?: number
  ProjectSaleServiceDeliveryNewBusinessAmount?: number
  ServiceDeliveryBacklogDetailListWaiting?: ServiceDeliveryBacklogDetailInfo[] | null
  ServiceDeliveryBacklogDetailListNewBusiness?: ServiceDeliveryBacklogDetailInfo[] | null
  ProjectSaleActualPrice?: number
  AllTeamMembersOfEmpCode?: string

  ProjectSaleCreateDate: string


  ProjectPipelineSearchStartDate: string
  ProjectPipelineSearchEndDate: string
  AllUnderEmpCode: string
  
  ProjectSaleAssignTo: string
}
